import React from "react";
import { Box, Button, Typography } from "@mui/material";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import { useBranding } from "../context/BrandingContext";

/**
 * Full-screen maintenance gate for Customer frontend.
 * Controlled entirely from Admin → App Settings.
 */
const MaintenanceScreen = () => {
  const { settings, mediaUrl, companyName, refresh } = useBranding();

  const banner = settings?.maintenanceBannerUrl
    ? mediaUrl(settings.maintenanceBannerUrl)
    : "";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        bgcolor: "var(--bg-color, #fff)",
        color: "var(--text-dark, #0F172A)",
      }}
    >
      <Box
        sx={{
          maxWidth: 520,
          width: "100%",
          textAlign: "center",
          p: 3,
          borderRadius: "var(--radius-lg, 12px)",
          border: "1px solid var(--border-color, #E2E8F0)",
          boxShadow: "var(--shadow-md)",
          bgcolor: "var(--surface-color, #fff)",
        }}
      >
        {banner ? (
          <Box
            component="img"
            src={banner}
            alt="Maintenance"
            sx={{
              width: "100%",
              maxHeight: 200,
              objectFit: "cover",
              borderRadius: 2,
              mb: 2,
            }}
          />
        ) : (
          <ConstructionOutlinedIcon
            sx={{ fontSize: 56, color: "var(--primary-color, #02026E)", mb: 1 }}
          />
        )}
        {/* <Typography variant="overline" color="text.secondary">
          {companyName}
        </Typography> */}
        <Typography variant="h5" fontWeight={700} mt={0.5} mb={1}>
          {settings?.maintenanceTitle || "We'll be back soon"}
        </Typography>
        <Typography variant="body1" color="text.secondary" mb={2}>
          {settings?.maintenanceMessage ||
            "Our platform is under scheduled maintenance."}
        </Typography>
        {settings?.maintenanceEta ? (
          <Typography variant="body2" fontWeight={600} mb={2}>
            {settings.maintenanceEta}
          </Typography>
        ) : null}
        <Button variant="outlined" onClick={() => refresh()}>
          Check again
        </Button>
      </Box>
    </Box>
  );
};

export default MaintenanceScreen;
